type Props = {
  list: string[];
  id?: string;
  value?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
};

export const InputSelect = (props: Props) => {
  const { list, id, value, onChange, disabled } = props;

  return (
    <select
      id={id}
      className="form-control select"
      value={value}
      disabled={disabled}
      onChange={(e) => {
        onChange(e.currentTarget.value);
      }}
    >
      {list.map((item) => (
        <option key={item} value={item}>
          {item}
        </option>
      ))}
    </select>
  );
};
